// extracted by mini-css-extract-plugin
module.exports = {"articleCategoriesContainer":"b2b-categories-block_articleCategoriesContainer__kVxMi","categoriesHeading":"b2b-categories-block_categoriesHeading__t3Hlj"};